var map = {
	"./blog.yml": 118,
	"./cloud.yml": 119,
	"./color.yml": 120,
	"./country.yml": 121,
	"./dio.yml": 122,
	"./doc.yml": 123,
	"./emoji.yml": 124,
	"./git.yml": 125,
	"./icon.yml": 126,
	"./license.yml": 127,
	"./link.yml": 128,
	"./metrics.yml": 129,
	"./people.yml": 130,
	"./soft.yml": 131,
	"./src.yml": 132,
	"./status.yml": 133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 117;